/* Main Layout - Full viewport desktop */
.main {
  position: fixed;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
}

/* Desktop Environment - Full viewport */
.desktopContainer {
  position: relative;
  flex: 1;
  overflow: hidden;
}

.desktop {
  position: absolute;
  inset: 0;
  background: var(--color-surface-sunken);
  overflow: hidden;
  background-image:
    radial-gradient(circle at 1px 1px, var(--color-border) 1px, transparent 0);
  background-size: 24px 24px;
  padding-bottom: 56px; /* Space for dock */
}
